import React, { useEffect, useState } from "react";
import MenuSection from "../components/MenuSection";
import { Box, Button, Dialog, Grid, Typography, useTheme } from "@mui/material";
import CategoriasTabs from "../components/kiosk-components/categorias-kiosk/categorias-kiosk";
import catalogo from "../api/catalogo";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { ArticulosListKiosk } from "../components/kiosk-components/articulos/articulo-list-kiosk";
import { useLocation, useNavigate } from "react-router-dom";
import { useProductStore } from "../hooks";
import fullBienvenido from "../images/full_bienvenido.png";
import sinBanderaBienvenido from "../images/sinBandera_bienvenido.png";
import Slide from '@mui/material/Slide';
import {
  buildComandaFromProductos,
  mapComandaToProductos,
} from "../helpers/kioskComanda";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const TiendaKioskPage = () => {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [grupoArticulo, setGrupoArticulo] = useState([]);
  const [modalWidth, setModalWidth] = useState(window.innerWidth < 700 ? "360px" : "900px");
  const [disabled, setDisabled] = useState(false);
  const {
    productos,
    idProductoArray,
    setIdProductoArray,
    resetProductos,
    updateProducto,
  } = useProductStore();
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedGrupo, setSelectedGrupo] = useState(grupoArticulo ? grupoArticulo[0]?.idCategoriaTotem : 1);
  const [openDialogInicio, setOpenDialogInicio] = useState(!location.state?.vieneDeDetalles);
  const background = localStorage.getItem("bandera") === "ypf" ? fullBienvenido : sinBanderaBienvenido;

  // Timer de inactividad
  useEffect(() => {
    let inactivityTimer;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      setOpenDialogInicio(false);
      inactivityTimer = setTimeout(() => {
        setOpenDialogInicio(true);
      }, 120000); // 2 minutos
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // Iniciar el timer solo si viene de detalles
    if (location.state?.vieneDeDetalles) {
      resetTimer();
    }

    return () => {
      clearTimeout(inactivityTimer);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [location.state?.vieneDeDetalles]);

  useEffect(() => {
      if(location.state?.limpiarProductos){
        resetProductos();
        localStorage.removeItem("comanda");
        setTotal(0);
        setTotalItems(0);
      }
  }, [location.state?.limpiarProductos]);

  const getComandaActual = () => {
    const comandaGuardada = JSON.parse(localStorage.getItem("comanda") || "{}");
    const tieneDetallesGuardados =
      Array.isArray(comandaGuardada.comandaDetalles) &&
      comandaGuardada.comandaDetalles.length > 0;

    if (tieneDetallesGuardados) {
      return comandaGuardada;
    }

    if (productos.length > 0) {
      const comandaDesdeProductos = buildComandaFromProductos(productos);
      localStorage.setItem("comanda", JSON.stringify(comandaDesdeProductos));
      return comandaDesdeProductos;
    }

    return { comandaDetalles: [], importeFinal: 0 };
  };

  useEffect(() => {
    const fetchGrupoArticulo = async () => {
      setLoading(true);
      try {
        const response = await catalogo.getCatalogoItems();
        if (response && response.items.length > 0) {
          setGrupoArticulo(response.items);
          if (response.items.length > 0) {
            setSelectedGrupo(response.items[0].idCategoriaTotem);
          }
        } else {
          console.error("Error: La respuesta no es un array válido", response);
        }
      } catch (error) {
        console.error("Error al obtener los grupos de artículos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrupoArticulo();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setModalWidth("360px");
        navigate("/")
      } else {
        setModalWidth("900px");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem('facturaInfo');

    if (location.state?.limpiarProductos) {
      return;
    }

    refreshComanda();
  }, [location.state?.limpiarProductos]);

  const handleAgregar = () => {
    const comandaActual = getComandaActual();
    const { productos: productosActualizados, nextIdProductoArray } =
      mapComandaToProductos(comandaActual, idProductoArray);

    updateProducto(productosActualizados);
    setIdProductoArray(nextIdProductoArray);

    localStorage.removeItem("comanda");
    navigate("/detalleskioskpage");
  };

  const handleGrupoSelect = idGrupoArticulo => {
    setSelectedGrupo(idGrupoArticulo);
  };

  const refreshComanda = () => {
    const comanda = getComandaActual();
    const tieneDetalles = Array.isArray(comanda.comandaDetalles) && comanda.comandaDetalles.length > 0;
    setTotal(tieneDetalles ? comanda.importeFinal : 0);
    setTotalItems(tieneDetalles ? comanda.comandaDetalles.length : 0);
  };

  return (
    <>
      <MenuSection />
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom></Typography>
        </Grid>
        <Grid item xs={3} sx={{ mr: -4 }}>
          <CategoriasTabs
            grupoArticulo={grupoArticulo}
            selectedGrupo={selectedGrupo}
            onGrupoSelect={handleGrupoSelect}
            innerWidth={1000}
            dynamicColor={theme.bandera.colorSecundario}
          />
        </Grid>
        <Grid item xs={9} sx={{}}>
          <ArticulosListKiosk
            grupoId={selectedGrupo}
            onComandaChange={refreshComanda}
            shouldRestoreComanda={!location.state?.limpiarProductos}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            textAlign: "initial",
            mt: 2,
            mb: -10,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ borderRight: "3px solid black", paddingRight: 2, marginRight: 2 }}>
              <ShoppingCartIcon sx={{ fontSize: 55 }} />
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="h5" fontWeight="bold">
                TOTAL: $
                {Number(total).toLocaleString("es-ES", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography variant="h6">Te vas a llevar {totalItems} item</Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            onClick={handleAgregar}
            sx={{
              backgroundColor: theme.bandera.colorSecundario,
              ":hover": {
                backgroundColor: theme.bandera.colorSecundario,
              },
              padding: "15px 50px",
              fontSize: "20px",
              borderRadius: "15px",
            }}
          >
            CONTINUAR
          </Button>
        </Grid>
      </Grid>

      <Dialog 
        open={openDialogInicio} 
        onClick={()=> setOpenDialogInicio(false)} 
        fullScreen 
        TransitionComponent={Transition}
        disableScrollLock
        keepMounted={false}
      >
        <img src={background} alt="Bienvenido" style={{ width: '100%', height: '100vh' }} />
      </Dialog>
    </>
  );
};
